export default __webpack_public_path__ + "static/media/GHSI ANNUAL SHAREHOLDERS MINUTES OF MEETING APRIL 20,2022.dd89c36d.pdf";